import { Icon, TextField } from '@nike/eds'
import { VirtualKeyboard } from 'components/keyboard'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface UpcEntryProps {
  upcBarcode: string
  error: string
  upcInputRef: React.RefObject<HTMLInputElement>
  setError: (error: string) => void
  onUpcChange: (value: string) => void
  onConfirm: () => void
}
const UPC_MAX_LENGTH = 19

export const UpcEntry = ({
  upcBarcode,
  error,
  upcInputRef,
  setError,
  onUpcChange,
  onConfirm
}: UpcEntryProps) => {
  const { t } = useTranslation()

  const enterKeyHandler = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onConfirm()
    }
  }

  useEffect(() => {
    if (upcBarcode.length > UPC_MAX_LENGTH) {
      setError(t('scan_unit.scan_upc.error'))
    } else {
      setError('')
    }
  }, [upcBarcode])
  return (
    <>
      <TextField
          id="upcBarcode"
          ref={upcInputRef}
          label={t('scan_unit.scan_upc.label')}
          placeholder={t('scan_unit.scan_upc.placeholder')}
          value={upcBarcode}
          onChange={e => { onUpcChange(e.currentTarget.value.trim()) }}
          hasErrors={error !== ''}
          errorMessage={error}
          onKeyUp={enterKeyHandler}
          beforeSlot={<Icon name="Scan"/>}
          autoFocus
      />
      <VirtualKeyboard
          text={upcBarcode}
          setText={onUpcChange}
          confirm={onConfirm}
          className='absolute w-[900px] mb-5'
          whichKeyboard='numpad'
      />
    </>
  )
}
